import { ApplicationEdge } from './types';

export function removeApplicationEdge(edges: ApplicationEdge[], applicationId: string): ApplicationEdge[] {
  return edges.filter(({ node }) => node.id !== applicationId);
}

export function getNextApplicationIdAfterRemoval(edges: ApplicationEdge[], applicationId: string): string {
  const currentAppIndex = edges.findIndex(({ node }) => node.id === applicationId);
  const remainingEdges = removeApplicationEdge(edges, applicationId);

  if (currentAppIndex === -1) {
    return remainingEdges[0]?.node.id || '';
  }

  return remainingEdges[currentAppIndex]?.node.id || remainingEdges[0]?.node.id || '';
}
